import { render, staticRenderFns } from "./WordsDictation2Form.vue?vue&type=template&id=abd22438&"
import script from "./WordsDictation2Form.vue?vue&type=script&lang=js&"
export * from "./WordsDictation2Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports